<div class="iso-content pt-2 ml-2">
  <div class="container-fluid">
    <div class="header-container mt-2">
      <button class="iso-link-button" [ngClass]="{'iso-selected': tab===0}" (click)="changeTab(0)">{{
        'bikeshop.users.staff' | translate}}</button>
      <button *ngIf="hasResources && isWorkshop" [ngClass]="{'iso-selected': tab===1}" class="iso-link-button"
              (click)="changeTab(1)">{{
        'bikeshop.users.working_hours' | translate}}</button>
      <button *ngIf="hasResources && isWorkshop" [ngClass]="{'iso-selected': tab===4}" class="iso-link-button"
              (click)="changeTab(4)">{{
        'bikeshop.users.sort_resources' | translate}}</button>
      <button *ngIf="hasResources && isWorkshop" [ngClass]="{'iso-selected': tab===3}" class="iso-link-button"
              (click)="changeTab(3)">{{
        'bikeshop.users.staff_leave' | translate}}</button>
      <button *ngIf="hasResources && isWorkshop" [ngClass]="{'iso-selected': tab===2}" class="iso-link-button"
              (click)="changeTab(2)">{{
        'bikeshop.users.closing_dates' | translate}}</button>

      <div class="loading" *ngIf="loading">
        <div class="loader"></div>
      </div>
    </div>
    <!-- <div class="content fill-content-height"> -->
    <div>
      <div class="row"></div>
      <div class="margin-top-16">
        <app-staff [loading]="loading" [users]="users" (getUsers)="getUsers()" [messageService]="messageService"
                   [isWorkshop]="isWorkshop" [isRentals]="isRentals"
                   *ngIf="tab===0"></app-staff>
        <!-- <app-working-hours [loading]="loading" [users]="users" [getUsers]="getUsers" *ngIf="tab===1"></app-working-hours> -->
        <app-working-schedule *ngIf="tab===1" [users]="users" (getUsers)="getUsers()"></app-working-schedule>
        <app-closing-dates *ngIf="tab===2" [users]="users"></app-closing-dates>
        <app-staff-leave *ngIf="tab===3" [users]="users"></app-staff-leave>
        <app-technicians-reorder *ngIf="tab===4" [users]="users"></app-technicians-reorder>
      </div>
    </div>
  </div>

  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>


</div>
